import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader m-auto is-size-3"
}
const _hoisted_2 = {
  key: 1,
  class: "message-body has-text-grey"
}
const _hoisted_3 = {
  key: 2,
  class: "table is-fullwidth is-hoverable"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Set"),
  /*#__PURE__*/_createElementVNode("th", { class: "has-text-right" }, "Navigation"),
  /*#__PURE__*/_createElementVNode("th")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Row = _resolveComponent("Row")!

  return (_ctx.datasetSets === null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_ctx.datasetSets.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No datasets "))
      : (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasetSets, (elementset) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: elementset.dataset.id + elementset.set
              }, [
                _createVNode(_component_Row, {
                  "corpus-id": _ctx.corpusId,
                  "element-set": elementset,
                  element: _ctx.element
                }, null, 8, ["corpus-id", "element-set", "element"])
              ]))
            }), 128))
          ])
        ]))
}